var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            inline: "",
            "label-width": "130px"
          }
        },
        [
          this.childData.repairType != 2
            ? _c(
                "div",
                { staticClass: "repair-container" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.houseBelong"),
                            prop: "upIdList"
                          }
                        },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "720px" },
                            attrs: {
                              options: _vm.options,
                              props: _vm.propstree,
                              placeholder: "请选择房间"
                            },
                            on: { change: _vm.checkSelectHouse },
                            model: {
                              value: _vm.childData.upIdList,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "upIdList", $$v)
                              },
                              expression: "childData.upIdList"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.urgencyDegree"),
                            prop: "situationType"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form-item-width",
                              attrs: {
                                placeholder: "请选择工单优先级",
                                clearable: ""
                              },
                              model: {
                                value: _vm.childData.situationType,
                                callback: function($$v) {
                                  _vm.$set(_vm.childData, "situationType", $$v)
                                },
                                expression: "childData.situationType"
                              }
                            },
                            _vm._l(_vm.degreeOption, function(item) {
                              return _c("el-option", {
                                key: item.dicValue,
                                attrs: {
                                  label: item.dicName,
                                  value: parseInt(item.dicValue)
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("table.source") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form-item-width",
                              attrs: {
                                placeholder: "请选择来源",
                                clearable: ""
                              },
                              model: {
                                value: _vm.childData.repairSource,
                                callback: function($$v) {
                                  _vm.$set(_vm.childData, "repairSource", $$v)
                                },
                                expression: "childData.repairSource"
                              }
                            },
                            _vm._l(_vm.sourceOption, function(item) {
                              return _c("el-option", {
                                key: item.dicValue,
                                attrs: {
                                  label: item.dicName,
                                  value: parseInt(item.dicValue)
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("table.appointmentTime") } },
                        [
                          _c("el-date-picker", {
                            staticClass: "form-item-width",
                            attrs: {
                              type: "date",
                              placeholder: "选择处理时间",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                              clearable: ""
                            },
                            model: {
                              value: _vm.childData.handleTime,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "handleTime", $$v)
                              },
                              expression: "childData.handleTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("table.position") } },
                        [
                          _c("el-input", {
                            staticClass: "form-item-width",
                            attrs: {
                              type: "text",
                              maxlength: "20",
                              clearable: "",
                              placeholder: "请输入安装位置"
                            },
                            model: {
                              value: _vm.childData.deviceAddress,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "deviceAddress", $$v)
                              },
                              expression: "childData.deviceAddress"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.contactMan"),
                            prop: "contact"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "form-item-width",
                            attrs: {
                              type: "text",
                              maxlength: "10",
                              clearable: "",
                              placeholder: "请输入联系人"
                            },
                            model: {
                              value: _vm.childData.contact,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "contact", $$v)
                              },
                              expression: "childData.contact"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.contactNumber"),
                            prop: "phone"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "form-item-width",
                            attrs: {
                              type: "text",
                              maxlength: "11",
                              clearable: "",
                              placeholder: "请输入联系电话"
                            },
                            model: {
                              value: _vm.childData.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "phone", $$v)
                              },
                              expression: "childData.phone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.workOrderType"),
                            prop: "orderType"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form-item-width",
                              attrs: {
                                placeholder: "请选择工单大类",
                                clearable: ""
                              },
                              on: { change: _vm.changeSelect },
                              model: {
                                value: _vm.childData.orderType,
                                callback: function($$v) {
                                  _vm.$set(_vm.childData, "orderType", $$v)
                                },
                                expression: "childData.orderType"
                              }
                            },
                            _vm._l(_vm.OrderOption, function(item) {
                              return _c("el-option", {
                                key: item.dicValue,
                                attrs: {
                                  label: item.dicName,
                                  value: item.dicValue
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.classWorkList"),
                            prop: "orderSubType"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form-item-width",
                              attrs: {
                                placeholder: "请选择工单子类",
                                clearable: ""
                              },
                              on: { focus: _vm.checkOrderType },
                              model: {
                                value: _vm.childData.orderSubType,
                                callback: function($$v) {
                                  _vm.$set(_vm.childData, "orderSubType", $$v)
                                },
                                expression: "childData.orderSubType"
                              }
                            },
                            _vm._l(_vm.documentOption, function(item) {
                              return _c("el-option", {
                                key: item.dicValue,
                                attrs: {
                                  label: item.dicName,
                                  value: item.dicValue
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.repairDetail"),
                            prop: "content"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "720px" },
                            attrs: {
                              type: "textarea",
                              maxlength: "200",
                              autosize: { minRows: 3, maxRows: 3 },
                              placeholder: "请输入报修详情"
                            },
                            model: {
                              value: _vm.childData.content,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "content", $$v)
                              },
                              expression: "childData.content"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "118px",
                        "text-align": "right",
                        color: "#707174",
                        "font-weight": "bold"
                      }
                    },
                    [_vm._v(" 上传图片 ")]
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-left": "130px" } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          attrs: {
                            "with-credentials": true,
                            action: _vm.uploadUrl,
                            "file-list": _vm.fileList,
                            name: "files",
                            "before-upload": _vm.beforeUpload,
                            "on-remove": _vm.handleRemove,
                            "on-success": _vm.handleSuccess,
                            "list-type": "picture-card",
                            "show-file-list": true,
                            "on-preview": _vm.handlePictureCardPreview
                          }
                        },
                        [_c("i", { staticClass: "el-icon-plus" })]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-dialog",
                    {
                      attrs: { visible: _vm.dialogVisible, title: "预览" },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisible = $event
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          width: "100%",
                          src: _vm.dialogImageUrl,
                          alt: ""
                        }
                      })
                    ]
                  )
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "repair-container" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.buildingBelong"),
                            prop: "upIdList"
                          }
                        },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "720px" },
                            attrs: {
                              options: _vm.buildingOptions,
                              props: _vm.propstree,
                              placeholder: "请先选择楼栋"
                            },
                            on: { change: _vm.checkSelectBuild },
                            model: {
                              value: _vm.childData.upIdList[0],
                              callback: function($$v) {
                                _vm.$set(_vm.childData.upIdList, 0, $$v)
                              },
                              expression: "childData.upIdList[0]"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.repairDevice"),
                            prop: "deviceId"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form-item-width",
                              attrs: {
                                filterable: "",
                                clearable: "",
                                disabled: _vm.isDisabled,
                                placeholder: "请选择报修设备"
                              },
                              on: { focus: _vm.checkHouseId },
                              model: {
                                value: _vm.childData.deviceId,
                                callback: function($$v) {
                                  _vm.$set(_vm.childData, "deviceId", $$v)
                                },
                                expression: "childData.deviceId"
                              }
                            },
                            _vm._l(_vm.deviceList, function(item) {
                              return _c("el-option", {
                                key: item.deviceId,
                                attrs: {
                                  label: item.deviceName,
                                  value: item.deviceId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("table.appointmentTime") } },
                        [
                          _c("el-date-picker", {
                            staticClass: "form-item-width",
                            attrs: {
                              type: "date",
                              placeholder: "选择处理时间",
                              format: "yyyy 年 MM 月 dd 日",
                              "value-format": "yyyy-MM-dd",
                              clearable: ""
                            },
                            model: {
                              value: _vm.childData.handleTime,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "handleTime", $$v)
                              },
                              expression: "childData.handleTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("table.position") } },
                        [
                          _c("el-input", {
                            staticClass: "form-item-width",
                            attrs: {
                              type: "text",
                              maxlength: "20",
                              clearable: "",
                              placeholder: "请输入安装位置"
                            },
                            model: {
                              value: _vm.childData.deviceAddress,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "deviceAddress", $$v)
                              },
                              expression: "childData.deviceAddress"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.urgencyDegree"),
                            prop: "situationType"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form-item-width",
                              attrs: {
                                placeholder: "请选择工单优先级",
                                clearable: ""
                              },
                              model: {
                                value: _vm.childData.situationType,
                                callback: function($$v) {
                                  _vm.$set(_vm.childData, "situationType", $$v)
                                },
                                expression: "childData.situationType"
                              }
                            },
                            _vm._l(_vm.degreeOption, function(item) {
                              return _c("el-option", {
                                key: item.dicValue,
                                attrs: {
                                  label: item.dicName,
                                  value: parseInt(item.dicValue)
                                },
                                on: { change: _vm.changeTowardValue }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.contactMan"),
                            prop: "contact"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "form-item-width",
                            attrs: {
                              type: "text",
                              maxlength: "10",
                              clearable: "",
                              placeholder: "请输入联系人"
                            },
                            model: {
                              value: _vm.childData.contact,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "contact", $$v)
                              },
                              expression: "childData.contact"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.contactNumber"),
                            prop: "phone"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "form-item-width",
                            attrs: {
                              type: "text",
                              maxlength: "11",
                              clearable: "",
                              placeholder: "请输入联系电话"
                            },
                            model: {
                              value: _vm.childData.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "phone", $$v)
                              },
                              expression: "childData.phone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.workOrderType"),
                            prop: "orderType"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form-item-width",
                              attrs: {
                                placeholder: "请选择工单大类",
                                clearable: ""
                              },
                              on: { change: _vm.changeSelect },
                              model: {
                                value: _vm.childData.orderType,
                                callback: function($$v) {
                                  _vm.$set(_vm.childData, "orderType", $$v)
                                },
                                expression: "childData.orderType"
                              }
                            },
                            _vm._l(_vm.OrderOption, function(item) {
                              return _c("el-option", {
                                key: item.dicValue,
                                attrs: {
                                  label: item.dicName,
                                  value: item.dicValue
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.classWorkList"),
                            prop: "orderSubType"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form-item-width",
                              attrs: {
                                placeholder: "请选择工单子类",
                                clearable: ""
                              },
                              on: { focus: _vm.checkOrderType },
                              model: {
                                value: _vm.childData.orderSubType,
                                callback: function($$v) {
                                  _vm.$set(_vm.childData, "orderSubType", $$v)
                                },
                                expression: "childData.orderSubType"
                              }
                            },
                            _vm._l(_vm.documentOption, function(item) {
                              return _c("el-option", {
                                key: item.dicValue,
                                attrs: {
                                  label: item.dicName,
                                  value: item.dicValue
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("table.repairDetail"),
                            prop: "content"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "720px" },
                            attrs: {
                              type: "textarea",
                              maxlength: "200",
                              autosize: { minRows: 3, maxRows: 4 },
                              placeholder: "请输入报修详情"
                            },
                            model: {
                              value: _vm.childData.content,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "content", $$v)
                              },
                              expression: "childData.content"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "118px",
                        "text-align": "right",
                        color: "#707174",
                        "font-weight": "bold"
                      }
                    },
                    [_vm._v(" 上传图片 ")]
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-left": "130px" } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          attrs: {
                            "with-credentials": true,
                            action: _vm.uploadUrl,
                            "file-list": _vm.fileList,
                            name: "files",
                            "before-upload": _vm.beforeUpload,
                            "on-remove": _vm.handleRemove,
                            "on-success": _vm.handleSuccess,
                            "list-type": "picture-card",
                            "show-file-list": true,
                            "on-preview": _vm.handlePictureCardPreview
                          }
                        },
                        [_c("i", { staticClass: "el-icon-plus" })]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-dialog",
                    {
                      attrs: { visible: _vm.dialogVisible, title: "预览" },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisible = $event
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          width: "100%",
                          src: _vm.dialogImageUrl,
                          alt: ""
                        }
                      })
                    ]
                  )
                ],
                1
              )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }